import {http_request} from '../../../../utils/http_request'
import {endpoint} from '../../../../config'
import authentication from '../../components/authentication'
export default async({user,snackBar,loader,history})=>{
  try{


loader.show() 

      const {data}=  await http_request({endpoint:endpoint,service:'apply-online-submit',variables:`user=${JSON.stringify(user)}&token=${authentication()}`})

   if(data.success){
 history.push('/orders')

   }
        }
        catch(e){

 snackBar.show(e.message)
        }
        finally{
          loader.hide()
        }


}
